import React from 'react';
import StatementInvoicesList from '../../../components/forms/statement/StatementInvoicesList';

const SummaryStatementView: React.FunctionComponent = function () {
    return <StatementInvoicesList displayActions />;
};

export default SummaryStatementView;
